import ReactToPrint, { ITriggerProps } from "react-to-print";
import useChequePrint, { ICheque } from "./useChequePrint";
import { ReactElement, ReactNode, useRef } from "react";

const PrintCheque = (props: { Btn: ReactElement, cheque: ICheque }) => {
    const { Btn, cheque } = props
    const contentRef = useRef<any>(null);
    const { cheqRef, chequeContent } = useChequePrint({
        cheque: {
            ...cheque,
        }
    })
    return (<>
        <div className="hidden">{chequeContent}</div>

        <ReactToPrint
            ref={contentRef}
            trigger={() => (
                Btn
            )}
            content={() => cheqRef.current}
        />
    </>
    );
}

export default PrintCheque;